import React, { useCallback, useEffect, useState } from 'react'
import Grid from '@mui/material/Grid2';
import "../catalogs.css";
import { useLocation, useNavigate } from 'react-router-dom';
import { faAngleRight, faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Tab, Tabs } from 'react-bootstrap';
import { apiService } from '../../../../services/apiService';
import GeneralCaseCats from '../../../../components/catalog/GeneralCaseCats';
import GeneralCaseKnowledge from './BasicTabs/GeneralCaseKnowledge';
import CaseAllDetails from './BasicCaseTabs/CaseAllDetails';
import { toast } from 'react-toastify';
import TaskAllDisccussCase from './BasicCaseTabs/TaskAllDisccussCase';
function IntakeForm() {
    const navigate = useNavigate();
    const location = useLocation();
    const userRole = localStorage.getItem('role');
    const [expanded, setExpanded] = useState(true);
    const parts_location = location.pathname.split("/");
    const caseSlug = parts_location[2] || null;
    const caseId = parts_location[4] || null;
    const [activeTabCase, setActiveTabCase] = useState("task");
    const [showCase, setShowCase] = useState(false);
    const [activeTab, setActiveTab] = useState("overview");
    const [loading, setLoading] = useState(false);
    const [intakeData, setIntakeData] = useState([]);
    const [allData, setAllData] = useState([]);
    // const [paginatedata, setPaginateData] = useState({});
    // const [currentPage, setCurrentPage] = useState(1);
    
    const fetchintakeData = useCallback(async (params = {}) => {
        setLoading(true);
        try {
            const response = await apiService.getRequest(`/cases/${caseSlug}/${caseId}`);
            if (response && response.success === true) {
                setIntakeData(response.data?.form_data);
                setAllData(response.data);
                setShowCase(response.data?.can_see_case);
            }else{
                if(response.error === "permission_denied"){
                    toast.error(response.message || "Permission Denied")
                    navigate("/dashboard")
                }
                if(response && response.authenticate === false){
                    await apiService.postRequest('/auth/logout');
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
            }
        } catch (error) {
            console.error('Error fetching tab data:', error);
        } finally {
            setLoading(false);
        }
    }, [caseSlug, caseId, navigate]);

    useEffect(() => {
        fetchintakeData();
    }, [fetchintakeData]);

    const sanitizeAndDisplayHTML = (html) => {
        if (!html) return '';
        const formattedHTML = html.replace(/\r\n|\r|\n/g, '<br />');
        return formattedHTML;
    };
  return (
    <div className='container-fluid px-0'>
        <div className="resizable-container d-flex">
            <GeneralCaseCats/>
            <div className='content_container_validate' style={{ flexGrow: 1 }}>
                <Grid size={{md:8,xs:12}} container flexDirection="column" className="jobseekerhead mb-3">
                    <span><b onClick={()=>navigate("/dashboard")}>Dashboard</b> 
                    <FontAwesomeIcon className='angleright' icon={faAngleRight} /> 
                    <b className="formatid_copyclip fw-bold text-decoration-none" style={{color:"#1A5298", width:"max-content"}}
                        onClick={async () => {
                            const url = `${window.location.origin}${allData?.case?.case_task_link}`;
                            const title = allData?.case?.gcase_summary?.short_description || "Case";
                            const textPlain = `${allData?.case?.case_formatted_id}: ${title}\n${url}`;
                            const textHtml = `<a href="${url}" target="_blank">${allData.case?.case_formatted_id}: ${title}</a>`;
                            try {
                            await navigator.clipboard.write([
                                new ClipboardItem({
                                "text/html": new Blob([textHtml], { type: "text/html" }),
                                "text/plain": new Blob([textPlain], { type: "text/plain" }),
                                }),
                            ]);
                            toast("Link copied to clipboard");
                            } catch (err) {
                            console.error("Failed to copy: ", err);
                            toast("Failed to copy link");
                            }
                        }}
                        >
                        {allData?.case?.case_formatted_id}
                    </b>
                    <FontAwesomeIcon className='angleright' icon={faAngleRight} />
                    <b className="formatid_copyclip fw-bold text-decoration-none" style={{color:"#1A5298", width:"max-content"}}
                        onClick={async () => {
                            const url = `${window.location.origin}${allData?.case?.case_task_link}`;
                            const title = allData?.case?.gcase_summary?.short_description || "Case";
                            const textPlain = `${allData?.task?.task_format_id} - ${allData?.case?.case_formatted_id}: ${title}\n${url}`;
                            const textHtml = `<a href="${url}" target="_blank">${allData?.task?.task_format_id} - ${allData.case?.case_formatted_id}: ${title}</a>`;
                            try {
                            await navigator.clipboard.write([
                                new ClipboardItem({
                                "text/html": new Blob([textHtml], { type: "text/html" }),
                                "text/plain": new Blob([textPlain], { type: "text/plain" }),
                                }),
                            ]);
                            toast("Link copied to clipboard");
                            } catch (err) {
                            console.error("Failed to copy: ", err);
                            toast("Failed to copy link");
                            }
                        }}
                        >
                        {allData?.task?.task_format_id}
                    </b>
                    </span>

                    {/* <p className="formatid_copyclip fw-bold text-decoration-none" style={{color:"#1A5298", width:"max-content"}}
                        onClick={async () => {
                            const url = `${window.location.origin}/${allData?.case_task_link}`;
                            const title = allData?.case?.gcase_summary?.short_description || "Case";
                            const textPlain = `${allData?.case?.case_formatted_id}: ${title}\n${url}`;
                            const textHtml = `<a href="${url}" target="_blank">${allData.case?.case_formatted_id}: ${title}</a>`;
                            try {
                            await navigator.clipboard.write([
                                new ClipboardItem({
                                "text/html": new Blob([textHtml], { type: "text/html" }),
                                "text/plain": new Blob([textPlain], { type: "text/plain" }),
                                }),
                            ]);
                            toast("Link copied to clipboard");
                            } catch (err) {
                            console.error("Failed to copy: ", err);
                            toast("Failed to copy link");
                            }
                        }}
                        >
                        {allData?.case?.case_formatted_id || "N/A"}
                    </p> */}
                </Grid>
                
                <Grid size={{sm:12}} container className="main_jobseeker tab_controllers">
                    {loading ? 
                        <div className='d-flex justify-content-center w-100'>
                            <img style={{ width: "100px" }} src={require('../../../../assets/pinkloader.gif')} alt='Loading...' />
                        </div> :
                        <Grid size={{sm:12}} container justifyContent="space-between">
                            <Grid size={{ lg: !showCase ? 12 : expanded ? 7.4 : 11.5, md: showCase? 12 : expanded ? 7 : 11, xs: 12 }} sx={{ transition: "all 0.35s cubic-bezier(0.4,0,0.2,1)" }} container alignContent="flex-start">
                            <Tabs
                                activeKey={activeTabCase}
                                onSelect={(key) => setActiveTabCase(key)}
                                defaultActiveKey="task"
                                id="uncontrolled-tab-example" className="mb-4 drafttabs_tabs"
                            >
                                <Tab eventKey="task" title="Task">
                                    <Grid size={{sm:12}} container alignItems="center">
                                        <Grid size={{xs:12}} container justifyContent="space-between" className="jobseekerhead border_botomer mario_fixers">
                                            <Grid container flexDirection="column">
                                                <h3>Intake Form<small className='small_headingstatuses'>{allData?.task?.status}</small></h3>
                                                <span>General Case</span>
                                            </Grid>
                                            <button onClick={()=> navigate("/catalogs/intake")} className='registersendbtn2 my-0'>Add New</button>
                                        </Grid>
                                        <Grid size={{sm:12}} container alignItems="center">
                                            <Grid size={{xs:12}} container flexDirection="column" justifyContent="center" className={`tab_controllers ${ expanded && "control_splits"}`}>
                                                <Tabs
                                                    activeKey={activeTab}
                                                    onSelect={(key) => setActiveTab(key)}
                                                    defaultActiveKey="overview"
                                                    id="uncontrolled-tab-example" className="mt-4 drafttabs_tabs"
                                                    >
                                                    <Tab eventKey="overview" title="Overview" className={`${ expanded && "expanded-grid"}`}>
                                                        <Grid size={{lg:12,xs:12}} container justifyContent="space-between" className="regiter_inputs i94validateinput">
                                                            <Grid size={{ xs:12}} container>
                                                                <Grid size={{xs:12}} container flexDirection="column">
                                                                    <span>Short Description<span style={{color:"red"}}> *</span></span>
                                                                    <p>{intakeData?.Q0020?.display_value}</p>
                                                                </Grid>
                                                            </Grid>
                                                            <Grid size={{sm:12, xs:12}} container flexDirection="column">
                                                                <span>Description<span style={{color:"Red"}}> *</span></span>
                                                                <p className='w-100' dangerouslySetInnerHTML={{ __html: sanitizeAndDisplayHTML(intakeData?.Q0030?.display_value) }} />
                                                            </Grid>
                                                            {intakeData?.Q0005?.display_value === "Yes" ?
                                                            <Grid size={{xs:12}} container flexDirection="column">
                                                                <span>Full Name<small className='red_starimpo'>*</small></span>
                                                                <p>{intakeData?.Q0010?.display_value}</p>
                                                            </Grid>
                                                            :<>
                                                            <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                                <span>Requested For<small className='red_starimpo'>*</small></span>
                                                                <p>{allData?.case?.requested_for_name}</p>
                                                            </Grid>
                                                            <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                                <span>Requested By<small className='red_starimpo'>*</small></span>
                                                                <p>{allData?.case?.requested_by_name}</p>
                                                            </Grid>
                                                            </>
                                                            }
                                                            <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                                <span>Contact Email<small className='red_starimpo'>*</small></span>
                                                                <p>{allData?.case?.requester_email}</p>
                                                            </Grid>
                                                            <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                                <span>Phone Number<small className='red_starimpo'>*</small></span>
                                                                <p>{intakeData?.Q0070?.display_value}</p>
                                                            </Grid>
                                                            {intakeData.Q0080?.display_value?.length > 0 &&
                                                            <Grid size={{xs:12}} container flexDirection="column">
                                                                <span>Attachments</span>
                                                                {intakeData && intakeData.Q0080?.display_value && intakeData?.Q0080?.display_value.map((data,index)=>(
                                                                    <p key={index}>File {index+1} <a className='view_fileshows' href={`${data}`} target="_blank" rel="noopener noreferrer">View</a></p>
                                                                ))}
                                                            </Grid>}
                                                            <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                                <span>Do you currently have any other general cases associated with this inquiry?<span style={{color:"Red"}}> *</span></span>
                                                                <p>{intakeData?.Q0090?.display_value}</p>
                                                            </Grid>
                                                            {intakeData?.Q0090?.display_value  === "Yes" &&
                                                            <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                                <span>Add case number<span style={{color:"red"}}> *</span></span>
                                                                <p>{intakeData?.Q0100?.display_value}</p>
                                                            </Grid>
                                                            }
                                                            {intakeData?.Q0110?.display_value &&
                                                            <Grid size={{md:5.5, sm:5.8, xs:12}} container flexDirection="column">
                                                                <span>Is this case internal to one of your Groups?<span style={{color:"red"}}> *</span></span>
                                                                <p>{intakeData?.Q0110?.display_value}</p>
                                                            </Grid>}
                                                            {intakeData?.Q0110?.display_value === "Yes" &&
                                                            <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                                <span>Ownership Group<span style={{color:"red"}}> *</span></span>
                                                                <p>{intakeData?.Q0120?.display_value}</p>
                                                            </Grid>
                                                            }
                                                            {userRole && userRole !== "job_seeker" &&<>
                                                            {intakeData?.Q0130?.display_value &&
                                                            <Grid size={{md:5.5, sm:5.8, xs:12}} container flexDirection="column">
                                                                <span>Are you submitting this request on behalf of requested for groups?<span style={{color:"red"}}> *</span></span>
                                                                <p>{intakeData?.Q0130?.display_value}</p>
                                                            </Grid>}
                                                            {intakeData?.Q0130?.display_value &&
                                                            <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                                <span>Please choose the group on behalf of which you are submitting this request.<span style={{color:"red"}}> *</span></span>
                                                                <p>{intakeData?.Q0130?.display_value}</p>
                                                            </Grid>
                                                            }
                                                            {intakeData?.Q0130?.display_value === "Yes" &&
                                                            <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                                <span>Please choose the group on behalf of which you are submitting this request.<span style={{color:"red"}}> *</span></span>
                                                                <p>{intakeData?.Q0140?.display_value}</p>
                                                            </Grid>
                                                            }</>}
                                                        </Grid>
                                                    </Tab>
                                                    <Tab eventKey="knowledge" title="Knowledge">
                                                        {activeTab === "knowledge" && <GeneralCaseKnowledge/>}
                                                    </Tab>
                                                </Tabs>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Tab>
                                {showCase && 
                                <Tab eventKey="case" title="Case">
                                    {activeTabCase === "case" && <CaseAllDetails expanded={expanded}/>}
                                </Tab>
                                }
                            </Tabs>
                            </Grid>
                            {showCase &&
                            <Grid alignContent="flex-start" size={{ lg: expanded ? 4.4 : 0.5, md: expanded ? 4.8 : 0.4, xs: 12, }} container className="border-start ps-3" sx={{ transition: "all 0.35s cubic-bezier(0.4,0,0.2,1)", overflow: "hidden", minWidth: expanded ? undefined : 0, }}>
                                <button onClick={() => setExpanded((prev) => !prev)} className='main_expanddisbtn'>
                                    {expanded ? <FontAwesomeIcon icon={faChevronRight} /> : <FontAwesomeIcon icon={faChevronLeft} />}
                                </button>
                                <Grid size={{xs:12}} container className={ expanded ? "control_splits" : "d-none"}>
                                    <Tabs
                                        defaultActiveKey="casediscuss"
                                        id="uncontrolled-tab-example" className="mt-4 drafttabs_tabs"
                                    >
                                        {showCase && 
                                        <Tab eventKey="casediscuss" title="Case Discussion">
                                            <TaskAllDisccussCase casediscuss={allData?.case?.is_requester}/>
                                        </Tab>
                                        }
                                    </Tabs>
                                    
                                </Grid>
                            </Grid>}
                        </Grid>}
                 </Grid>
                        
            </div>
        </div>
    </div>
  )
}

export default IntakeForm
